export default __webpack_public_path__ + "5a31f024f6d43f2604bafd029981127f.png";